import React, { useMemo } from 'react';
import { GetPasswordsByCompany } from '../../../graphql/conexiones';
import { banks } from '../../conexiones/functions';

const BankPasswordDropdown = ({
  value,
  onChange,
  companyId,
  id,
  className = '',
  disabled = false,
}) => {
  const { data, fetching } = GetPasswordsByCompany(companyId);
  const passwords = useMemo(
    () => data?.allPasswordsByCompanyId || [],
    [data?.allPasswordsByCompanyId],
  );

  const options = useMemo(
    () =>
      (banks(passwords) || [])
        .filter((password) => password.isActive !== false || String(password.id) === String(value))
        .sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), 'es'))
        .map((password) => ({
          value: String(password.id),
          label: String(password.name || ''),
        })),
    [passwords, value],
  );

  const handleChange = (event) => {
    const nextValue = event.target.value;
    const option = options.find((item) => item.value === nextValue);
    onChange?.(event, {
      value: nextValue,
      text: option?.label || '',
    });
  };

  return (
    <select
      id={id}
      className={`create-rule-select ${className}`.trim()}
      value={value || ''}
      onChange={handleChange}
      disabled={disabled || !companyId || fetching}
    >
      <option value="">
        {fetching ? 'Cargando cuentas corrientes...' : 'Seleccione cuenta corriente'}
      </option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default BankPasswordDropdown;
